<button type="button"
        class="sms-trigger"
        data-guide="shell-module"
        [class.sms-trigger--collapsed]="collapsed"
        [class.sms-trigger--open]="open"
        [attr.aria-expanded]="open"
        [title]="collapsed ? 'Switch module — ' + label : 'Switch module'"
        (click)="toggle($event)">
  @if (collapsed) {
    <span class="sms-mark">
      <img [src]="mark" alt="Spectrum" />
      <i class="fas fa-grip sms-badge" aria-hidden="true"></i>
    </span>
  } @else {
    <img class="sms-lockup" [src]="lockup" alt="Spectrum — Simplifying Institution Management" />
    <span class="sms-switch">
      <i class="fas fa-grip" aria-hidden="true"></i>
      <span class="sms-module">{{ label }}</span>
      <i class="fas fa-chevron-down sms-chevron" [class.sms-chevron--open]="open"></i>
    </span>
  }
</button>

@if (open) {
  <div class="module-menu"
       [style.top.px]="panelTop"
       [style.left.px]="panelLeft"
       [style.width.px]="panelWidth"
       [style.max-height.px]="panelMaxHeight"
       (click)="$event.stopPropagation()">
    <div class="module-menu__header">
      <div class="module-menu__title">
        <span class="module-menu__title-icon">
          <i class="fas fa-layer-group"></i>
        </span>
        <div>
          <span class="module-menu__eyebrow">Switch Module</span>
          <strong>Choose workspace</strong>
        </div>
      </div>
      @if (currentModule) {
        <span class="module-menu__current">{{ currentModule!.moduleName }}</span>
      }
    </div>
    <div class="module-menu__meta">
      <span>{{ filteredModules.length }} shown</span>
      <span class="module-menu__hint">
        <i class="fas fa-up-right-from-square"></i>
        Ctrl / &#8984; + click opens a new tab
      </span>
    </div>
    <div class="module-menu__search">
      <i class="fas fa-search"></i>
      <input type="text" [(ngModel)]="search" placeholder="Search modules..." />
      @if (search) {
        <button type="button" (click)="search = ''">
          <i class="fas fa-times"></i>
        </button>
      }
    </div>
    <div class="module-menu__grid">
      @for (module of filteredModules; track module.moduleName) {
        <div class="module-menu__row">
          <button
            class="module-menu__item"
            [class.module-menu__item--active]="isCurrent(module)"
            type="button"
            (click)="select(module, $event)"
            (auxclick)="select(module, $event)">
            <span class="module-menu__icon module-menu__icon-shell"
                  [style.background]="moduleIcon(module).bg"
                  [style.color]="moduleIcon(module).color">
              <i [class]="moduleIcon(module).icon"></i>
            </span>
            <span class="module-menu__item-copy">
              <span class="module-menu__item-name">{{ module.moduleName }}</span>
            </span>
            @if (isCurrent(module)) {
              <span class="module-menu__check">
                <i class="fas fa-check"></i>
              </span>
            }
          </button>
          <button
            class="module-menu__newtab"
            type="button"
            title="Open in a new tab"
            aria-label="Open {{ module.moduleName }} in a new tab"
            (click)="openInNewTab(module, $event)">
            <i class="fas fa-up-right-from-square"></i>
          </button>
        </div>
      } @empty {
        <div class="module-menu__empty">
          <i class="fas fa-search"></i>
          <span>No modules found</span>
        </div>
      }
    </div>
  </div>
}
